module.exports = __webpack_public_path__ + "static/media/logo_sample.d0950031.svg";